import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useUserRole } from "@/hooks/useUserRole";

const PageNotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const token = useSelector(
    (state: { auth: { token: string } }) => state.auth.token,
  );
  const { roleRoutes, isRoleLoaded } = useUserRole();


  const handleRedirect = () => {
    if (token) {
      if (!isRoleLoaded) return;
      try {
        navigate(roleRoutes[0]);
      } catch (error) {
        console.error("unexpected error:", error);
        navigate("/dashboard");
      }
    } else {
      navigate("/login"); // Redirect to login if no token
    }
  };

  return (
    <div className="flex h-screen flex-col items-center justify-center bg-gray-50 p-4 text-center">
      {/* Heading */}
      <h1 className="text-sidebar-600 mb-4 text-4xl font-bold sm:text-5xl md:text-6xl">
        {t("notFound.title")}
      </h1>

      {/* Description */}
      <p className="mb-8 text-lg text-gray-600 sm:text-xl md:text-2xl">
        {t("notFound.description")}
      </p>

      {/* Button */}
      <button
        onClick={handleRedirect}
        className="rounded-lg bg-sidebar px-6 py-3 text-sm font-semibold text-skyblue transition duration-300 sm:text-base"
      >
        {token ? t("notFound.goHome") : t("notFound.goToLogin")}
      </button>
    </div>
  );
};

export default PageNotFound;
